import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { action_setBoardContractFilterComponentSycFlag, action_setBoardElements, action_setBoardViewStructureGeneric, action_setBoardViewStructureSpecific, action_setBoardViewStructureSpecificBase, action_setBoardViewVariableDataserieValues } from '../../../reducers/actions/KPI/actions';
import { getBoardComponentInfoRecursiveValues, getBoardStructure, getBoardStructureGeneric, getElementsByBoardId } from '../../../services/sKPI/board.service';
import { getBoardVariableDataSerieValues } from '../../../services/sKPI/dataserie.service';
import { enum__ComponentType } from '../../../common/Dictionaries';
import moment from 'moment';
import { getComponentDataByTypeId } from './managerComponentData';
import { isNullUndefinedOrEmpty } from '../../../common/Helpers';

const useGetBoardStructureGeneric = (boardTypeId, elementId, boardStructureGeneric, setBoardStructureGeneric) => {  
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardStructureGeneric(boardTypeId, !isNullUndefinedOrEmpty(elementId) ? elementId : 0);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    dispatch(action_setBoardViewStructureGeneric(response.data, elementId));
                    setBoardStructureGeneric(response.data)
                }
                else {
                    dispatch(action_setBoardViewStructureGeneric([], null));
                    setBoardStructureGeneric([])
                }
            }
            catch (error) {
                dispatch(action_setBoardViewStructureGeneric([], null));
                setBoardStructureGeneric([])
            }
        }
        
        if ((boardTypeId !== null && boardTypeId !== undefined) && boardStructureGeneric === null) {
            getData()
        }
    }, [boardTypeId, elementId, boardStructureGeneric, setBoardStructureGeneric]);
}

const useGetBoardStructureSpecific = (boardId, elementId, boardStructureSpecific, setBoardStructureSpecific) => {  
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardStructure(boardId, true);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (response.data.length !== 0) {
                        dispatch(action_setBoardViewStructureSpecific(response.data, elementId));
                        setBoardStructureSpecific(response.data)
                    }
                    else {
                        dispatch(action_setBoardViewStructureSpecific([], null));
                        setBoardStructureSpecific([])
                    }
                }
                else {
                    dispatch(action_setBoardViewStructureSpecific([], null));
                    setBoardStructureSpecific([])
                }
            }
            catch (error) {
                dispatch(action_setBoardViewStructureSpecific([], null));
                setBoardStructureSpecific([])
            }
        }
        
        if ((boardId !== null && boardId !== undefined) && (elementId !== null && elementId !== undefined) && boardStructureSpecific === null) {
            getData()
        }
    }, [boardId, elementId, boardStructureSpecific, setBoardStructureSpecific]);
}

const useGetBoardStructureComponentsData2 = (componentFilters, hasPageElementId, elementId, boardStructure, calendarOptions, componentDataFilled, reportMode) => {  
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                const componentsStructures = boardStructure.flatMap(item => 
                    item.l_structure.flatMap(structure => 
                        structure.l_container.flatMap(container => 
                            container.l_components_info
                        )
                    )
                );
                
                const distinctComponents = componentsStructures.filter((component, index, self) =>
                    index === self.findIndex((t) => (
                        t.componentTypeId === component.componentTypeId
                    ))
                );

                let componentsMatch = null;
                let componentsMatchResult = [];

                let elementsResponse = await getElementsByBoardId(boardStructure[0].id);
                if (elementsResponse.data.succeeded) {
                    dispatch(action_setBoardElements(elementsResponse.data.data));
                }
                else {
                    dispatch(action_setBoardElements([]));
                }

                await getComponentDataByTypeId(componentFilters, {hasPageElementId: hasPageElementId, elementId: elementId}, componentsStructures, distinctComponents, componentsMatchResult, componentsMatch, calendarOptions, dispatch, reportMode);
            }
            catch (error) {
                dispatch(action_setBoardViewStructureSpecific([], null));
            }
        }

        if (boardStructure !== null && boardStructure !== undefined && boardStructure.length > 0 && (componentDataFilled === false)) {
            dispatch(action_setBoardContractFilterComponentSycFlag(true));
            getData()
        }
    }, [componentFilters, hasPageElementId, elementId, boardStructure, calendarOptions, componentDataFilled]);
}

const useGetBoardStructureComponentsData = (componentFilters, hasPageElementId, elementId, boardStructure, calendarOptions, structureFireGetData, setStructureFireGetData) => {  
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                const componentsStructures = boardStructure.flatMap(item => 
                    item.l_structure.flatMap(structure => 
                        structure.l_container.flatMap(container => 
                            container.l_components_info
                        )
                    )
                );
                
                const distinctComponents = componentsStructures.filter((component, index, self) =>
                    index === self.findIndex((t) => (
                        t.componentTypeId === component.componentTypeId
                    ))
                );

                let componentsMatch = null;
                let componentsMatchResult = [];

                let elementsResponse = await getElementsByBoardId(boardStructure[0].id);
                if (elementsResponse.data.succeeded) {
                    dispatch(action_setBoardElements(elementsResponse.data.data));
                }
                else {
                    dispatch(action_setBoardElements([]));
                }

                //Gatillar sincronización de filtros.
                //dispatch(action_setBoardContractFilterComponentSycFlag(true))

                await getComponentDataByTypeId(componentFilters, {hasPageElementId: hasPageElementId, elementId: elementId}, componentsStructures, distinctComponents, componentsMatchResult, componentsMatch, calendarOptions, dispatch);
            }
            catch (error) {
                dispatch(action_setBoardViewStructureSpecific([], null));
            }
        }

        console.log((boardStructure !== null && boardStructure !== undefined && boardStructure.length > 0 && (structureFireGetData === true)));

        if (boardStructure !== null && boardStructure !== undefined && boardStructure.length > 0 && (structureFireGetData === true)) {
            setStructureFireGetData && setStructureFireGetData(false);
            getData()
        }
    }, [componentFilters, hasPageElementId, elementId, boardStructure, calendarOptions, structureFireGetData, setStructureFireGetData]);
}

const useGetBoardComponentInfoRecursiveValues = (componentFilters, containerComponent, calendarOptions, boardComponentInfoValues, setBoardComponentInfoValues) => {  
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = null;
            
                if (containerComponent.componentTypeId >= 17 || (containerComponent.componentTypeId <= 15 && containerComponent.componentTypeId >= 6) ) {
                    serviceResponse = await getBoardComponentInfoRecursiveValues(
                        componentFilters,
                        containerComponent.boardId,
                        containerComponent.componentTypeId,
                        null,
                        null,
                        calendarOptions.value.calendarSelectorId, 
                        calendarOptions.value.periodStartDate, 
                        calendarOptions.value.periodEndsDate,
                        calendarOptions.value.displayAgregationId
                    );

                    const response = serviceResponse.data;

                    if (response.succeeded) {
                        if (response.data.length !== 0) {
                            setBoardComponentInfoValues(response.data);
                        }
                        else {
                            setBoardComponentInfoValues([]);
                        }
                    }
                    else {
                        setBoardComponentInfoValues([]);
                    }
                }
            }
            catch (error) {
                setBoardComponentInfoValues([]);
            }
        }
        
        if ((containerComponent !== null) && boardComponentInfoValues === null) {
            getData()
        }
    }, [componentFilters, containerComponent, calendarOptions, boardComponentInfoValues, setBoardComponentInfoValues]);
}

const useGetBoardVariableDataSerieValues = (structures, boardId, elementId, dataserieId, obJFilters, objDataSerieValueList, setBoardVariableDataserieValues) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        
        const getData = async () => {
            try {
                const componentsInfoStructures = structures.flatMap(item => 
                    item.l_structure.flatMap(structure => 
                        structure.l_container.flatMap(container => 
                            container.l_components_info
                        )
                    )
                );

                const componentsDataseriesStructures = structures.flatMap(item => 
                    item.l_structure.flatMap(structure => 
                        structure.l_container.flatMap(container => 
                            container.l_components
                        )
                    )
                );

                const componentsStructures = [...componentsInfoStructures, ...componentsDataseriesStructures];
                const distinctComponents = componentsStructures.filter((component, index, self) =>
                    index === self.findIndex((t) => (
                        t.componentTypeId === component.componentTypeId
                    ))
                );

                if (distinctComponents.filter(x => x.componentTypeId <= enum__ComponentType.LIST || x.componentTypeId === enum__ComponentType.ELEMENT_KPI_SCOPE).length > 0) {
                    let calendarFilterStartDate = obJFilters.value.periodStartDate !== null ?
                    moment(obJFilters.value.periodStartDate).format('MM/DD/YYYY') : null;
            
                    let calendarFilterEndDate = obJFilters.value.periodEndsDate !== null ?
                    moment(obJFilters.value.periodEndsDate).format('MM/DD/YYYY') : null;
    
                    const serviceSerieResponse = await getBoardVariableDataSerieValues(boardId, elementId, dataserieId, obJFilters.value.calendarSelectorId, obJFilters.value.displayAgregationId, calendarFilterStartDate, calendarFilterEndDate);
    
                    let elementDataserie = serviceSerieResponse.data.data.find(x => x.dataserieId === dataserieId)
    
                    dispatch(action_setBoardViewVariableDataserieValues(serviceSerieResponse.data.data));
                    setBoardVariableDataserieValues(serviceSerieResponse.data.data)
                }
                else {
                    dispatch(action_setBoardViewVariableDataserieValues([]));
                    setBoardVariableDataserieValues([])
                }
            }
            catch (error) {
                dispatch(action_setBoardViewVariableDataserieValues([]));
                setBoardVariableDataserieValues([])
            }

            obJFilters.setter(prevState => ({
                ...prevState,
                fireFilter: false
            }))
        }
        
        if (structures !== null && boardId !== null && obJFilters.value.displayAgregationId !== null && elementId !== null && (obJFilters.value.fireFilter === true || objDataSerieValueList === null)) {
            getData()
        }

    }, [structures, boardId, elementId, dataserieId, obJFilters, objDataSerieValueList, setBoardVariableDataserieValues]);
}

export {
    useGetBoardStructureGeneric,
    useGetBoardStructureSpecific,
    useGetBoardStructureComponentsData,
    useGetBoardStructureComponentsData2,
    useGetBoardVariableDataSerieValues,
    useGetBoardComponentInfoRecursiveValues
}